import Layout from "../components/layout/Layout";
import { ShieldX } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui";

const NotAuthorizedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <Layout hideFooter={true} className="flex flex-1">
      <div className="flex flex-1 flex-col items-center justify-center text-center px-4 mx-auto gap-6 sm:gap-8">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center">
              <ShieldX className="w-10 h-10 text-red-500" />
            </div>
          </div>

          {/* Main Heading */}
          <h1>
            {t('errors.access_denied')}
          </h1>

          {/* Description */}
          <p className="text-sm sm:text-lg text-dark-invirtus/70">
            {t('errors.no_permission')}
            <span className="block mt-2">
              {t('errors.contact_admin')}
            </span>
          </p>

          {/* Action Button */}
          <Button
            label={t('errors.go_to_home')}
            intent="primary"
            type="contained"
            onClick={() => navigate("/")}
          />
      </div>
    </Layout>
  );
};

export default NotAuthorizedPage; 